(() => {
  'use strict';

  const VARIANT_CLASS = 'convert-countdown-hidden';

  const hideCountdown = () => {
    document.documentElement.classList.add(VARIANT_CLASS);
    
    // Hide all countdown timers and show fallback messages
    const timers = document.querySelectorAll('.announcement-timer');
    const fallbacks = document.querySelectorAll('.convert-countdown-fallback');
    
    timers.forEach(timer => {
      timer.style.display = 'none';
    });
    
    fallbacks.forEach(fallback => {
      fallback.style.display = 'block';
    });

    // Hide Message 2 
    const message2Items = document.querySelectorAll('.announcement-text-2');
    message2Items.forEach(item => {
      if (!item.dataset.originalDisplay) {
        item.dataset.originalDisplay = item.style.display || '';
      }
      item.style.display = 'none';
    });
  };

  const showCountdown = () => {
    document.documentElement.classList.remove(VARIANT_CLASS);
    
    // Show all countdown timers and hide fallback messages
    const timers = document.querySelectorAll('.announcement-timer');
    const fallbacks = document.querySelectorAll('.convert-countdown-fallback');
    
    timers.forEach(timer => {
      timer.style.display = '';
    });
    
    fallbacks.forEach(fallback => {
      fallback.style.display = 'none';
    });

    // Show Message 2 
    const message2Items = document.querySelectorAll('.announcement-text-2');
    message2Items.forEach(item => {
      item.style.display = item.dataset.originalDisplay || '';
      delete item.dataset.originalDisplay;
    });
  };

  window.convertCountdownTest = {
    control() {
      showCountdown();
    },
    
    variant() {
      hideCountdown();
    },
    
    reset() {
      this.control();
    }
  };

  document.addEventListener('page:load', () => {
    if (document.documentElement.classList.contains(VARIANT_CLASS)) return;
    window.convertCountdownTest.control?.();
  });
})();
